import { render, staticRenderFns } from "./AddAlternatePrintable.vue?vue&type=template&id=7682115a&scoped=true&"
import script from "./AddAlternatePrintable.vue?vue&type=script&lang=js&"
export * from "./AddAlternatePrintable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7682115a",
  null
  
)

export default component.exports